import { SiteJsonLd } from "./layout/SiteJsonLd";
import { Header } from "./layout/Header";
import { Footer } from "./layout/Footer";

export const Layout = ({ children }) => (
  <div className="min-h-screen">
    <SiteJsonLd />
    <Header />
    <main>{children}</main>
    <Footer />
  </div>
);
